export default "__VITE_ASSET__be707200__"